import {
  AfterViewInit,
  Directive,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[give-focus-desktop]'
})
export class GiveFocusDesktopDirective implements AfterViewInit {
  constructor ( private el: ElementRef ) {}

  ngAfterViewInit () : void {
    if ( window.innerWidth > 1024 ) {
      setTimeout(() => {
        this.el.nativeElement.focus({ preventScroll: true });
      });
    }
  }
}
